import { message, notification } from 'antd';
import axios from 'axios';
import { addRequestInterceptors } from './handle-public-key';

axios.interceptors.request.use(...addRequestInterceptors());

const codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。',
};

function jumptoSearchUrl(data, url) {
  let _url = '?';
  for (const key in data) {
    if (data[key]) {
      _url += `${key}=${data[key]}&`;
    }
  }
  return url + _url.slice(0, _url.length - 1);
}
const checkStatus = (response) => {
  // console.log('response=============》1', response)
  if (
    (response.status >= 200 && response.status < 300) ||
    // 针对于要显示后端返回自定义详细信息的status, 配置跳过
    response.status === 400 ||
    response.status === 500
  ) {
    return response;
  }
  const errortext = codeMessage[response.status] || response.statusText;
  notification.error({
    message: `请求错误 ${response.status}: ${response.url}`,
    description: errortext,
  });
  const error = new Error(errortext);
  error.name = response.status;
  error.response = response;
  throw error;
};

const checkServerCode = (response) => {
  // console.log('response=============》3', response);
  if (!response) return;
  if (response.status >= 200 && response.status < 300) {
    return {
      success: true,
      ...response,
    };
  }
  if (response.status === 400) {
    notification.error({
      message: response.message || codeMessage[response.status],
    });
  } else if (response.status === 401) {
    if (window.location.hash.endsWith('/login')) return false;
    notification.error({
      message: response.message || codeMessage[response.status],
    });
    window.location.replace('/#/login');
  } else if (response.status === 404) {
    notification.error({
      message: response.message || codeMessage[response.status],
    });
  } else if (response.status === 500) {
    notification.error({
      message: response.message || codeMessage[response.status],
    });
  } else if (response.status === 422) {
    notification.error({
      message: response.data.message || codeMessage[response.status],
    });
  }
  return response;
};
const pending = {};
const { CancelToken } = axios;
const removePending = (key, isRequest = false) => {
  if (pending[key] && isRequest) {
    pending[key]('取消重复请求');
  }
  delete pending[key];
};
const getRequestIdentify = (config, isReuest = false) => {
  let { url } = config;
  if (isReuest) {
    url = config.baseURL + config.url.substring(1, config.url.length);
  }
  return config.method === 'get'
    ? encodeURIComponent(url + JSON.stringify(config.params))
    : encodeURIComponent(config.url + JSON.stringify(config.data));
};
axios.defaults.timeout = 10000;
axios.interceptors.request.use(
  (config) => {
    const requestData = getRequestIdentify(config, true);
    removePending(requestData, true);
    config.cancelToken = new CancelToken((c) => {
      pending[requestData] = c;
    });
    return config;
  },
  (err) => {
    return Promise.reject(err);
  },
);
axios.interceptors.response.use(
  (response) => {
    // 把已经完成的请求从 pending 中移除
    const requestData = getRequestIdentify(response.config);
    removePending(requestData);
    return response;
  },
  (err) => {
    if (err.code === 'ERR_NETWORK' || err.code === 'ECONNABORTED') {
      notification.error({
        message: '请求超时',
      });
    }
    if (err && err.response) {
      checkServerCode(err.response);
    }
    return Promise.reject(err.response.data);
  },
);

/**
 * Requests a URL, returning a promise.
 *
 * @param  {string} url       请求地址
 * @param  {object} [option]  配置参数
 * @return {object}           An object containing either "data" or "err"
 */
export default function request(url, option) {
  // console.log(url, option)
  const options = {
    ...option,
  };

  const defaultOptions = {
    method: 'POST',
    data: {},
    credentials: 'include',
  };
  const newOptions = { ...defaultOptions, ...options };

  newOptions.headers = {
    ...newOptions.headers,
    // 客户端认证, 或者加上token
    // Authorization:''
  };
  const userInfo = sessionStorage.getItem('userInfo');
  if (option.login && userInfo) {
    const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
    newOptions.headers.Authorization = `Bearer ${userInfo.token}`;
  }
  if (newOptions.method === 'POST' || newOptions.method === 'PUT' || newOptions.method === 'DELETE') {
    if (!(newOptions.body instanceof FormData)) {
      newOptions.headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        ...newOptions.headers,
      };
      newOptions.data = JSON.stringify(newOptions.body);
    } else {
      // newOptions.body is FormData
      newOptions.headers = {
        Accept: 'application/json',
        ...newOptions.headers,
      };
    }
  }
  return axios({
    url: newOptions.method === 'GET' && newOptions.body ? `${url}?${newOptions.body}` : url,
    ...newOptions,
  })
    .then(checkStatus)
    .then((response) => {
      // console.log('response=========》2', response);
      if (newOptions.method === 'DELETE' || response.status === 204) {
        // return response.text()
        return response;
      }
      return response;
    })
    .then(checkServerCode)
    .catch((e) => {
      const { response } = e;
      // console.log('response=========》4', response);
      checkServerCode(response);
      return Promise.reject(response);
    });
}
